import { render, staticRenderFns } from "./NewOrderList.vue?vue&type=template&id=4405412f&scoped=true"
import script from "./NewOrderList.vue?vue&type=script&lang=js"
export * from "./NewOrderList.vue?vue&type=script&lang=js"
import style0 from "./NewOrderList.vue?vue&type=style&index=0&id=4405412f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4405412f",
  null
  
)

export default component.exports